import React from "react";

const RatingCircles = ({ rating, bgColour }) => {
    const part = rating % 1 != 0;
    const whole = rating - part;

    const items = [];

    for (let i = 0; i < whole; i++) {
        items.push(<div key={"full-" + i} className={"w-4 h-4 rounded-full " + bgColour} />);
    }
    let paddersToAdd = 5 - items.length;

    if (part) {
        items.push(
            <div className="flex rounded-full" key={"part"}>
                <div className={"w-2 h-4 rounded-l-full " + bgColour} />
                <div className="w-2 h-4 bg-gray-300 rounded-r-full" />
            </div>
        );

        paddersToAdd = paddersToAdd - 1;
    }
    for (let i = 0; i < paddersToAdd; i++) {
        items.push(<div key={"empty-" + i} className="w-4 h-4 bg-gray-300 rounded-full" />);
    }
    return <div className="flex gap-0.5 ml-1">{items}</div>;
};
export default RatingCircles;
